export const MOCK_KEYWORDS = [
    { key: '1', word: '철제선반', search: 49500, rank: 3 },
    { key: '2', word: '선반철제', search: 28380, rank: 7 },
    { key: '3', word: '베란다선반', search: 13030, rank: 0 },
    { key: '4', word: '창고선반', search: 11530, rank: 12 },
    { key: '5', word: '앵글선반', search: 9030, rank: 0 },
    { key: '6', word: '조립식선반', search: 6800, rank: 21 },
    { key: '7', word: '경량선반', search: 2150, rank: 0 },
    { key: '8', word: '선반', search: 1470, rank: 54 },
];

export const MOCK_REPORT = {
    score: 72,
    stats: [
        { value: '89,200', suffix: '건' }, // index 0: 월간 검색량
        { value: '12,847', suffix: '개' }, // index 1: 총 상품 수
        { value: '높음', suffix: '' }, // index 2: 경쟁 강도
        { value: '32,400', suffix: '원' }, // index 3: 평균가
        { value: '4,210', suffix: '개' }, // index 4: 평균 리뷰 수
        { value: '2,183', suffix: '개' }, // index 5: 평균 찜 수
        { value: '0', suffix: '개' }, // index 6: 찜 수 fallback
        { value: '0', suffix: '개' }, // index 7: 찜 수 fallback
        { value: '8,742', suffix: '건' }, // index 8: 6개월 판매량
    ],
    product: {
        id: '8294719482',
        rank: 7,
        title: '스탠리 스타일 이중단열 진공 텀블러 500ml',
        price: 28900,
        reviewCount: 2847,
        reviewScore: 4.76,
        recentReviewCount: 312,
        recentReviewScore: 4.82,
        wishCount: 1203,
        store: '데일리홈마켓',
        category: '주방/식기 > 텀블러',
        tags: '텀블러,보온텀블러,스탠리텀블러,이중단열,500ml',
        image: 'https://images.unsplash.com/photo-1577937927133-66ef06acdf18?w=360&q=80',
        channelVisit: {
            오늘: 621,
            전체: 84201,
        },
    },
    diagnostic: {
        score: 72,
        kwCompetitiveness: {
            score: 55,
            rankedKwCount: 4,
            totalKwCount: 8,
        },
        reviewHealth: {
            score: 78,
            photoRatioPct: 42,
            negRatioPct: 2.1,
            avgCompReviewCount: 4210,
        },
        avgWishCount: 2183,
        avgPrice: 32400,
    },
    keywordInfo: {
        relKeyword: '텀블러',
        total: 89200,
        pc: 15160,
        mobile: 74040,
        totalClick: 4210,
        pcClick: 620,
        mobileClick: 3590,
        totalCtr: 4.72,
        pcCtr: 4.09,
        mobileCtr: 4.85,
        blogCount: 241080,
        cafeCount: 89240,
        compIdx: '높음',
    },
    expertAnalysis: {
        marketTrend:
            '텀블러 시장은 홈카페·친환경 트렌드 확산으로 꾸준히 성장 중입니다. 4~5월 봄 시즌에 검색량이 15~20% 급상승하며, 가성비와 디자인 경쟁이 심화되고 있습니다.',
        priceStrategy:
            '현재 가격(28,900원)은 상위 10 평균(32,400원) 대비 약 11% 저렴합니다. 가성비 포지셔닝이 효과적이나, 프리미엄 소재·기능 강조 시 소폭 가격 인상도 고려해볼 수 있습니다.',
        keywordStrategy:
            "상품명에 '이중단열', '진공', '500ml' 등 스펙 키워드가 잘 반영되어 있습니다. '보온텀블러', '스텐텀블러' 태그 추가로 추가 유입 확대를 권장합니다.",
        reviewStrategy:
            '평점(4.76)은 우수하나 리뷰 수가 경쟁사 대비 부족합니다. 초기 구매자 대상 포토리뷰 이벤트 진행 및 CS 응대 강화로 리뷰 볼륨을 확보하세요.',
        competitive:
            '뛰어난 보온 성능과 합리적 가격이 핵심 강점입니다. 상세페이지에 성능 테스트 결과와 사용 시나리오를 추가하면 전환율 개선에 유리합니다.',
        actionPlan: [
            '포토리뷰 이벤트로 리뷰 1,000개 이상 확보 (3개월 목표)',
            '태그에 "보온텀블러", "스텐텀블러" 추가 및 상품명 최적화',
            '찜하기 유도 프로모션으로 평균(2,183개) 달성 목표',
        ],
    },
    rankHistory: [
        { date: '2026-03-21', rank: 15, isToday: false },
        { date: '2026-03-24', rank: 14, isToday: false },
        { date: '2026-03-27', rank: 12, isToday: false },
        { date: '2026-03-31', rank: 11, isToday: false },
        { date: '2026-04-04', rank: 9, isToday: false },
        { date: '2026-04-08', rank: 8, isToday: false },
        { date: '2026-04-12', rank: 7, isToday: false },
        { date: '2026-04-16', rank: 8, isToday: false },
        { date: '2026-04-20', rank: 7, isToday: true },
    ],
    shoppingTrends: {
        genderTrend: {
            results: [
                {
                    data: [
                        { period: '2026-04', group: 'f', ratio: 54 },
                        { period: '2026-04', group: 'm', ratio: 46 },
                    ],
                },
            ],
        },
        deviceTrend: {
            results: [
                {
                    data: [
                        { period: '2026-04', group: 'mo', ratio: 83 },
                        { period: '2026-04', group: 'pc', ratio: 17 },
                    ],
                },
            ],
        },
        ageTrend: {
            results: [
                {
                    data: [
                        { period: '2026-04', group: '10', ratio: 5 },
                        { period: '2026-04', group: '20', ratio: 22 },
                        { period: '2026-04', group: '30', ratio: 38 },
                        { period: '2026-04', group: '40', ratio: 24 },
                        { period: '2026-04', group: '50', ratio: 8 },
                        { period: '2026-04', group: '60', ratio: 3 },
                    ],
                },
            ],
        },
        keywordTrend: {
            results: [
                {
                    data: [
                        { period: '2025-05-01', ratio: 45 },
                        { period: '2025-06-01', ratio: 42 },
                        { period: '2025-07-01', ratio: 38 },
                        { period: '2025-08-01', ratio: 36 },
                        { period: '2025-09-01', ratio: 40 },
                        { period: '2025-10-01', ratio: 44 },
                        { period: '2025-11-01', ratio: 52 },
                        { period: '2025-12-01', ratio: 68 },
                        { period: '2026-01-01', ratio: 62 },
                        { period: '2026-02-01', ratio: 58 },
                        { period: '2026-03-01', ratio: 72 },
                        { period: '2026-04-01', ratio: 89 },
                    ],
                },
            ],
        },
    },
    seasonalityAnalysis: {
        seasonalityScore: 48,
        recentChange: 23.6,
        peakMonth: 12,
        risingMonths: [3, 4, 11, 12],
        fallingMonths: [6, 7, 8],
        aiAnalysis: {
            status: '주의',
            summary:
                '겨울철 및 봄철 환절기에 텀블러 수요가 강하게 일어나는 계절적 특성이 있습니다.',
            advice: '환절기 보온 마케팅 및 디자인 개편 주기를 겨울/봄 시작 전에 맞추어 준비하는 전략이 유효합니다.',
        },
    },
    keywords: [
        { key: '1', word: '텀블러', search: 89200, rank: 7 },
        { key: '2', word: '보온텀블러', search: 24800, rank: 12 },
        { key: '3', word: '스텐텀블러', search: 18600, rank: 15 },
        { key: '4', word: '대용량텀블러', search: 12400, rank: 0 },
        { key: '5', word: '빨대텀블러', search: 9800, rank: 0 },
        { key: '6', word: '진공텀블러', search: 8200, rank: 21 },
        { key: '7', word: '밀폐텀블러', search: 5400, rank: 0 },
        { key: '8', word: '보냉텀블러', search: 4200, rank: 54 },
    ],
    relatedQueries: [
        { word: '보온병', search: 45200, rank: 18 },
        { word: '예쁜텀블러', search: 15400, rank: 0 },
        { word: '스탠리텀블러', search: 94800, rank: 45 },
        { word: '락앤락텀블러', search: 32100, rank: 0 },
        { word: '카페텀블러', search: 8900, rank: 0 },
        { word: '휴대용보온병', search: 6200, rank: 11 },
        { word: '빨대보틀', search: 5100, rank: 0 },
    ],
    autocompleteKeywords: [
        { word: '텀블러백', search: 12400, rank: 0 },
        { word: '텀블러추천', search: 9800, rank: 0 },
        { word: '텀블러세정제', search: 8200, rank: 0 },
        { word: '텀블러파우치', search: 5400, rank: 0 },
        { word: '텀블러500ml', search: 4200, rank: 7 },
        { word: '텀블러브랜드', search: 3900, rank: 0 },
        { word: '텀블러빨대', search: 2800, rank: 0 },
    ],
    competitors: [
        {
            rank: 1,
            name: '스타벅스 SS 다이아몬드 보온 텀블러',
            price: 35000,
            reviewCount: 8412,
            wishCount: 4201,
            todayVisit: 2310,
            totalVisit: 254100,
            tags: ['텀블러', '스타벅스', '보온'],
            imageUrl: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/starbucks',
        },
        {
            rank: 2,
            name: '락앤락 클래식 보온보냉 스테인리스 텀블러',
            price: 29900,
            reviewCount: 7123,
            wishCount: 3842,
            todayVisit: 1872,
            totalVisit: 198400,
            tags: ['텀블러', '보온보냉', '락앤락'],
            imageUrl: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/locknlock',
        },
        {
            rank: 3,
            name: '써모스 진공단열 이중구조 텀블러 600ml',
            price: 42000,
            reviewCount: 6234,
            wishCount: 3210,
            todayVisit: 1541,
            totalVisit: 142100,
            tags: ['텀블러', '써모스', '진공단열'],
            imageUrl: 'https://images.unsplash.com/photo-1577937927133-66ef06acdf18?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/thermos',
        },
        {
            rank: 4,
            name: '코멕스 탄탄이 보온보냉병 스테인리스',
            price: 24900,
            reviewCount: 5841,
            wishCount: 2847,
            todayVisit: 1203,
            totalVisit: 98700,
            tags: ['텀블러', '보온병', '코멕스'],
            imageUrl: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/komax',
        },
        {
            rank: 5,
            name: '지플렉스 리유저블 아이스 텀블러 480ml',
            price: 22000,
            reviewCount: 4912,
            wishCount: 2103,
            todayVisit: 980,
            totalVisit: 84200,
            tags: ['텀블러', '친환경', '아이스'],
            imageUrl: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/gflex',
        },
        {
            rank: 6,
            name: '카멜백 에디 인슐레이티드 텀블러',
            price: 38000,
            reviewCount: 3701,
            wishCount: 1842,
            todayVisit: 842,
            totalVisit: 64200,
            tags: ['텀블러', '카멜백', '인슐레이티드'],
            imageUrl: 'https://images.unsplash.com/photo-1577937927133-66ef06acdf18?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/camelbak',
        },
        {
            rank: 7,
            name: '스탠리 스타일 이중단열 진공 텀블러 500ml',
            price: 28900,
            reviewCount: 2847,
            wishCount: 1203,
            todayVisit: 621,
            totalVisit: 84201,
            tags: ['텀블러', '보온텀블러', '이중단열'],
            imageUrl: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/dailyhome',
            mine: true,
        },
        {
            rank: 8,
            name: '타이거 마그보틀 보온 스테인리스 텀블러',
            price: 34000,
            reviewCount: 2612,
            wishCount: 1087,
            todayVisit: 543,
            totalVisit: 45200,
            tags: ['텀블러', '타이거', '마그보틀'],
            imageUrl: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/tiger',
        },
        {
            rank: 9,
            name: '블랙핑크 콜라보 한정판 보온 텀블러',
            price: 45000,
            reviewCount: 1943,
            wishCount: 3901,
            todayVisit: 712,
            totalVisit: 51200,
            tags: ['텀블러', '한정판', '콜라보'],
            imageUrl: 'https://images.unsplash.com/photo-1577937927133-66ef06acdf18?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/blackpink',
        },
        {
            rank: 10,
            name: 'OXO 굿 그립스 리유저블 텀블러 355ml',
            price: 26900,
            reviewCount: 1621,
            wishCount: 892,
            todayVisit: 398,
            totalVisit: 31200,
            tags: ['텀블러', 'OXO', '리유저블'],
            imageUrl: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=150&q=80',
            mallUrl: 'https://smartstore.naver.com/oxo',
        },
    ],
    priceMap: {
        myPrice: 28900,
        avgPrice: 32400,
        totalCount: 10,
        outlierCount: 0,
        filteredPrices: [22000, 24900, 26900, 28900, 29900, 34000, 35000, 38000, 42000, 45000],
    },
    reviewData: {
        reviews: [
            {
                id: 1,
                score: 5,
                content:
                    '보온력이 정말 대단해요! 아침에 뜨겁게 넣으면 저녁까지 따뜻합니다. 디자인도 심플하고 예뻐서 매일 들고 다녀요.',
                hasPhoto: true,
                repurchase: false,
                createDate: '2026-04-18T10:00:00Z',
            },
            {
                id: 2,
                score: 5,
                content:
                    '가성비 최고입니다. 유명 브랜드 정품보다 훨씬 저렴한데 품질은 비슷한 것 같아요. 세척도 편하고 만족스러워요.',
                hasPhoto: true,
                repurchase: true,
                createDate: '2026-04-12T10:00:00Z',
            },
            {
                id: 3,
                score: 4,
                content:
                    '전반적으로 좋은데 뚜껑이 조금 헐렁한 느낌이에요. 보온력은 아주 훌륭합니다.',
                hasPhoto: false,
                repurchase: false,
                createDate: '2026-04-08T10:00:00Z',
            },
            {
                id: 4,
                score: 2,
                content:
                    '뚜껑 밀폐가 약해서 가방 안에서 새는 경우가 있었어요. 교체 받았는데도 비슷하네요.',
                hasPhoto: false,
                repurchase: false,
                createDate: '2026-04-01T10:00:00Z',
            },
        ],
        reviewAmount: {
            totalReviewCount: 2847,
            averageReviewScore: 4.76,
        },
        reviewSummary: {
            productReviewInfo: {
                photoReviewCount: 1195,
                score5ReviewCount: 2023,
                score4ReviewCount: 513,
                score3ReviewCount: 171,
                score2ReviewCount: 85,
                score1ReviewCount: 55,
            },
        },
        aiReviewAnalysis: {
            positivePoints: [
                '보온·보냉 성능이 기대 이상으로 매우 우수함',
                '가격 대비 내구성과 마감이 뛰어나 가성비 만족도가 높음',
                '모던하고 심플한 디자인으로 전 연령대 호평',
            ],
            negativePoints: [
                '뚜껑 고무 패킹의 밀폐력이 약해 가끔 누수가 발생한다는 보고',
                '본체 무게가 약간 무겁게 느껴져 휴대성이 떨어진다는 후기',
                '입구가 깊어 내부 세척 시 전용 솔이 꼭 필요함',
            ],
            summary:
                '전반적으로 뛰어난 보온 성능과 높은 가성비로 큰 만족도를 이끌어내고 있으나, 누수 관련 패킹 개선이 중요한 과제로 남아 있습니다. 고객 경험을 한층 더 극대화하기 위해 보온 테스트 정보와 함께 세척 팁을 상세 페이지에 기재하는 것을 적극 추천합니다.',
            topKeywords: [
                { keyword: '보온', count: 512 },
                { keyword: '디자인', count: 387 },
                { keyword: '가성비', count: 341 },
                { keyword: '보냉', count: 298 },
                { keyword: '세척', count: 201 },
            ],
            complaintKeywords: [
                { keyword: '뚜껑 누수', count: 87 },
                { keyword: '무게감', count: 64 },
                { keyword: '세척 불편', count: 52 },
                { keyword: '표면 긁힘', count: 38 },
            ],
            topicScores: {
                보온성: 95,
                디자인: 88,
                가성비: 92,
                편의성: 76,
                내구성: 84,
            },
            starAnalysis: {
                5: {
                    summary: '보온 성능이 아주 만족스럽고 디자인이 이뻐 휴대하기 좋습니다.',
                    pros: ['뛰어난 보온성', '세련된 디자인', '완벽한 마감'],
                    cons: [],
                },
                4: {
                    summary: '대체로 만족하지만 뚜껑 손잡이가 약간 불편합니다.',
                    pros: ['가성비 우수', '우수한 보냉력'],
                    cons: ['손잡이 그립감'],
                },
                3: {
                    summary: '무난하게 쓸만하나 기대를 크게 충족하진 못하네요.',
                    pros: ['평범한 성능'],
                    cons: ['무게가 다소 무거움'],
                },
                2: {
                    summary: '보온은 잘되는데 물이 한두 방울씩 샙니다.',
                    pros: ['기본 보온력'],
                    cons: ['미세 누수 발생'],
                },
                1: {
                    summary: '불량품을 받은 것 같아요. 뚜껑 결합이 제대로 안 됩니다.',
                    pros: [],
                    cons: ['뚜껑 불량', '누수 심함'],
                },
            },
        },
    },
};
